// Formatters de dates réutilisables — constantes hoistées pour éviter les
// instanciations répétées de `Intl.*Format` dans les lists virtualisées
// ou re-rendues fréquemment (pattern Adv P9 Story 2.2).

const RELATIVE_TIME_FORMAT = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' })
const DATE_MEDIUM_FORMAT = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium' })

// Renvoie une date relative (« il y a 3 jours », « dans 2 mois »).
// Fallback « — » si iso === null ou date invalide.
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const ts = new Date(iso).getTime()
  if (Number.isNaN(ts)) return '—'
  const diffMs = ts - Date.now()
  const diffMin = Math.round(diffMs / 60000)
  if (Math.abs(diffMin) < 60) return RELATIVE_TIME_FORMAT.format(diffMin, 'minute')
  const diffH = Math.round(diffMin / 60)
  if (Math.abs(diffH) < 48) return RELATIVE_TIME_FORMAT.format(diffH, 'hour')
  // On bascule sur les mois à partir de ~27 jours, en utilisant la longueur
  // moyenne d'un mois (30.44) pour éviter un saut brutal entre « 29 jours »
  // et « 1 mois ». Au-delà de 12 mois, on passe en années.
  const diffDExact = diffMs / (1000 * 60 * 60 * 24)
  if (Math.abs(diffDExact) < 27) {
    return RELATIVE_TIME_FORMAT.format(Math.round(diffDExact), 'day')
  }
  const diffMo = Math.round(diffDExact / 30.44)
  if (Math.abs(diffMo) < 12) return RELATIVE_TIME_FORMAT.format(diffMo, 'month')
  const diffY = Math.round(diffDExact / 365.25)
  return RELATIVE_TIME_FORMAT.format(diffY, 'year')
}

// Renvoie une date absolue (« 20 avr. 2026 »). Fallback « — » si invalide.
export function formatDateMedium(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return DATE_MEDIUM_FORMAT.format(d)
}
